import { t } from 'i18next'
import React from 'react'

const OrderInfoCard = (props) => {
    const {orderInfo,color, t} = props
    return (
        <div className="col-lg-4 col-md-6 col-sm-12 col-xl-4">
            <div className="track-card">
                <div className="track-card-heading">
                    {t('orderInfo')}
                </div>
                <div className="track-card-body">
                    <div className="d-flex">
                        <label className="track-card-text">{t('orderNo')}:&nbsp;</label>
                        <p className="track-card-text">{orderInfo && orderInfo.vblen}</p>
                    </div>

                    <div className="d-flex">
                        <label className="track-card-text">{t('purchaseOrder')}:&nbsp;</label>
                        <p className="track-card-text">{orderInfo && orderInfo.purchNo}</p>
                    </div>

                    <div className="d-flex">
                        <label className="track-card-text">{t('orderStatus')}:&nbsp;</label>
                        <p className="track-card-text">{orderInfo && orderInfo.status}</p>
                    </div>

                    <div className="d-flex">
                        <label className="track-card-text">{t('orderType')}:&nbsp;</label>
                        <p className="track-card-text">{orderInfo && orderInfo.orderType}</p>
                    </div>
                </div>
            </div>
            <div className="track-border" style={{backgroundColor:color}}></div>
        </div>
    )
}

export default OrderInfoCard